import {
  Box,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { DynamicKeyValueInput } from "../../../EditModelbuilder/Rules Editing/DynamicKeyValueInput";

export default function CaseProRestType({ control, path }) {
  return (
    <Box
      mt={4}
      p={3}
      bg="orange.50"
      borderRadius="md"
      border="1px solid"
      borderColor="orange.200"
    >
      <Text fontWeight="medium" color="orange.700" mb={2}>
        🌐 REST Configuration
      </Text>

      {/* URL / Processor / Template */}
      <SimpleGrid columns={3} spacing={4}>
        <FormControl>
          <FormLabel>API URL</FormLabel>
          <Controller
            control={control}
            name={`${path}.URL`}
            render={({ field }) => (
              <Input {...field} placeholder="https://example.com/api" />
            )}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Processor (optional)</FormLabel>
          <Controller
            control={control}
            name={`${path}.PROCESSOR`}
            render={({ field }) => (
              <Input {...field} placeholder="teams_notification" />
            )}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Template (optional)</FormLabel>
          <Controller
            control={control}
            name={`${path}.BODY.TEMPLATE`}
            render={({ field }) => (
              <Input {...field} placeholder="Adaptive card template ID" />
            )}
          />
        </FormControl>
      </SimpleGrid>

      {/* Headers / URL Params / Body */}
      <Box mt={4}>
        <SimpleGrid columns={2} spacing={4}>
          <Box>
            <FormLabel>Headers</FormLabel>
            <DynamicKeyValueInput
              control={control}
              name={`${path}.HEADERS`}
              placeholderKey="Key"
              placeholderValue="Value"
            />
          </Box>

          <Box>
            <FormLabel>URL Params</FormLabel>
            <DynamicKeyValueInput
              control={control}
              name={`${path}.URL_PARAMS`}
              placeholderKey="Key"
              placeholderValue="Value"
            />
          </Box>
        </SimpleGrid>

        <Box mt={4}>
          <FormLabel>Body</FormLabel>
          <DynamicKeyValueInput
            control={control}
            name={`${path}.BODY`}
            placeholderKey="Field"
            placeholderValue="Value"
          />
        </Box>
      </Box>
    </Box>
  );
}
